import { useBackend } from "../../services";
import { IStore } from "./interfaces";
import { useGetPaginatedAttributes } from "../attributes/useGetPaginatedAttributes";
import {
  IGetPaginatedAttributeProps,
  IPublicGetPaginatedAttributeProps
} from "../attributes/interfaces";
import { useCollectionManager } from "../collections/useCollectionManager";
import { PageSizeHelper } from "../../models/PageSizeHelper";
import { useUser } from "../session";
import { UserRole } from "../users";
import { DataStorage } from "../../models/DataStorage";

export const useGetStores = (isPublic: boolean, setLoading: (loading: boolean) => void) => {
  const { get } = useBackend();
  const { getCurrentCollection } = useCollectionManager();
  const [currentUser] = useUser.useState();
  const getStores = (parameters: IGetPaginatedAttributeProps) => get("stores", parameters);
  const getPublicStores = (parameters: IPublicGetPaginatedAttributeProps) =>
    get("stores/shared/public", parameters);
  return useGetPaginatedAttributes<IStore>(
    PageSizeHelper.stores(currentUser?.role ?? UserRole.common),
    isPublic ? getPublicStores : getStores,
    setLoading,
    DataStorage.storeStorage,
    isPublic,
    true,
    getCurrentCollection(isPublic)?.uuid
  );
};
